import { useCanResolveSalesforceIngest } from '@/features/SalesforceIngest/hooks/useCanResolveSalesforceIngest'
import { salesforceIngestResolveRoute } from '@/features/SalesforceIngest/pages/ResolveIngestPage'
import { Button } from '@chakra-ui/react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

/**
 * The entry point onto the resolve form, for the header of the Salesforce
 * account pages.
 *
 * Gated on the same hook the route redirects on, so the link and the page it
 * leads to cannot drift into offering a bounce. The pages hosting it are
 * gated more widely (`{ADMIN, OPERATOR, READER}` against this form's
 * `{ADMIN, GTM}`), which is exactly why the link carries its own check rather
 * than inheriting the page's.
 *
 * Renders nothing until the roles have settled: showing it and then removing
 * it is worse than showing it a moment late.
 */
export function ResolveIngestLink() {
  const { t } = useTranslation('features', { useSuspense: false })
  const { canResolve, isResolved } = useCanResolveSalesforceIngest()

  if (!isResolved || !canResolve) {
    return null
  }

  return (
    <Button asChild variant="outline" size="sm">
      <Link to={salesforceIngestResolveRoute.to}>
        {String(t('salesforceIngest.entryPoint'))}
      </Link>
    </Button>
  )
}
